// 文章中心
import request from "@/utils/request.js";
// let path = "/api";
const Banner = {
  /**
   * @param page @type String 页码
   * @param pageSize @type String 条数
   */
  queryList: async (data) => {
    return await request("post", "/config-center/banner/list", data);
  },

  /**
   * 添加/修改用户
   * @param id @type String id  再新增的时候直接不传这个参数 在修改的时候再传
   * @param enable @type Number   是否启用：0 表示禁用  1 表示启用，
   * @param imgUrl @type String   图片地址
   * @param targetUrl @type String   目标链接地址
   * @param delStatus @type Number   未删除为0   删除为1
   * @param createTime  @type String   创建时间
   */
  addOrUpDate: async (data) => {
    return await request("post", "/config-center/banner/add", data);
  },
  /**
   * 登录获取token
   * @param id @type String id
   */
  delAcList: async (data) => {
    return await request("get", "/config-center/banner/logic-del", data);
  },
};
export default Banner;



// WEBPACK FOOTER //
// ./src/api/banner.js